module.exports = __webpack_public_path__ + "static/aboutus_c-e59adbbdafa1ba5f120ca8dc6e358b9d.jpg";